/* vlsniy.aroma: SMS-підписка на спецпропозиції (головна, картка товару, будь-який лендинг).
   Ставить форму під фільтрами на головній і під блоком «Збери свій набір» у картці товару.
   Для лендингів: у Custom Liquid / HTML додай <div data-vl-sms-slot="landing"></div>.
   Дані йдуть у веб-застосунок Google Apps Script (лист leads, status = subscriber). */
(function () {
  var EP = 'https://script.google.com/macros/s/AKfycbw3R_7PimRfDYGIuZeXzWQikLfYa6L315VULvWwtZpCpCmfCM4fmbt8bYgqiPIdjvtJrA/exec';
  var TITLE = 'Отримуйте спецпропозиції в SMS';
  var SUB = 'Акції, новинки та вигідні набори. Без спаму, відписатися можна будь-коли.';
  var BTN = 'Підписатися';
  var DONE = 'Готово! Дякуємо, надішлемо вам спецпропозиції.';
  var CONSENT = 'Погоджуюсь отримувати SMS від vlsniy.aroma: нагадування про кошик і замовлення, акції та спецпропозиції. Відписатися можна будь-коли: напишіть нам.';
  var POLICY = '/policies/privacy-policy';

  var CSS = '.vl-sms{max-width:var(--page-width,1000px);margin:24px auto 18px;padding:16px 18px;background:#fff;border:1px solid rgba(57,64,52,.12);border-radius:12px;color:#394034;box-sizing:border-box;font-family:"Jost",sans-serif;text-align:left}' +
    '.vl-sms[hidden]{display:none}' +
    '.vl-sms__title{font-family:"Mulish",sans-serif;font-weight:800;font-size:15px;margin-bottom:4px}' +
    '.vl-sms__sub{font-size:14px;line-height:1.4;margin-bottom:12px;opacity:.85}' +
    '.vl-sms__form{display:flex;gap:8px;flex-wrap:wrap}' +
    '.vl-sms__tel{flex:1 1 200px;min-width:0;display:flex;align-items:center;height:44px;border:1px solid rgba(57,64,52,.3);border-radius:8px;background:#fff;box-sizing:border-box;overflow:hidden}' +
    '.vl-sms__tel:focus-within{border-color:#5A613B;box-shadow:0 0 0 2px rgba(90,97,59,.18)}' +
    '.vl-sms__prefix{padding:0 4px 0 14px;font-size:16px;color:#394034;font-weight:600;user-select:none}' +
    '.vl-sms__form input.vl-sms__phone{flex:1 1 auto;min-width:0;height:100%;padding:0 14px 0 4px;border:0;outline:0;background:transparent;font:inherit;font-size:16px;color:#394034;box-shadow:none}' +
    '.vl-sms__btn{height:44px;padding:0 22px;border:0;border-radius:8px;background:#394034;color:#fff;font-family:"Mulish",sans-serif;font-weight:800;font-size:14px;cursor:pointer;text-decoration:none!important}' +
    '.vl-sms__btn[disabled]{opacity:.55;cursor:default}' +
    '.vl-sms__hp{position:absolute!important;left:-9999px!important;width:1px;height:1px;opacity:0}' +
    '.vl-sms__consent{display:flex;gap:8px;align-items:flex-start;margin-top:12px;font-size:12.5px;line-height:1.4;cursor:pointer}' +
    '.vl-sms__consent input{margin-top:2px;flex:0 0 auto;width:16px;height:16px;accent-color:#5A613B}' +
    '.vl-sms__consent a{color:#5A613B;text-decoration:underline;white-space:nowrap}' +
    '.vl-sms__msg{margin-top:10px;font-size:14px;min-height:0}' +
    '.vl-sms__msg.is-err{color:#a33}.vl-sms__msg.is-ok{color:#5A613B;font-weight:600}' +
    '@media (max-width:749px){.vl-sms{margin:20px 0 14px;padding:14px}}';

  function digits(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.indexOf('380') === 0) d = d.slice(3); else if (d.charAt(0) === '0') d = d.slice(1);
    return d.slice(0, 9);
  }
  function fmt(d) {
    var o = d.slice(0, 2);
    if (d.length > 2) o += ' ' + d.slice(2, 5);
    if (d.length > 5) o += ' ' + d.slice(5, 7);
    if (d.length > 7) o += ' ' + d.slice(7, 9);
    return o;
  }

  function build(src) {
    var KEY = 'vl_sms_lead_v2_' + src, TTL = 30 * 864e5;
    try { var t0 = +localStorage.getItem(KEY); if (t0 && Date.now() - t0 < TTL) return null; } catch (e) {}
    var root = document.createElement('div');
    root.className = 'vl-sms';
    root.setAttribute('data-vl-sms-js', src);
    root.innerHTML =
      '<div class="vl-sms__title"></div><div class="vl-sms__sub"></div>' +
      '<form class="vl-sms__form" novalidate><div class="vl-sms__tel"><span class="vl-sms__prefix">+380</span>' +
      '<input type="tel" class="vl-sms__phone" inputmode="numeric" autocomplete="tel-national" maxlength="12" placeholder="XX XXX XX XX" aria-label="Номер телефону, 9 цифр після +380"></div>' +
      '<button type="submit" class="vl-sms__btn"></button>' +
      '<input type="text" class="vl-sms__hp" tabindex="-1" autocomplete="off" aria-hidden="true"></form>' +
      '<label class="vl-sms__consent"><input type="checkbox" class="vl-sms__ok"><span class="vl-sms__ctext"></span>' +
      '<a href="' + POLICY + '" target="_blank" rel="noopener">Політика конфіденційності</a></label>' +
      '<div class="vl-sms__msg" aria-live="polite"></div>';
    root.querySelector('.vl-sms__title').textContent = TITLE;
    root.querySelector('.vl-sms__sub').textContent = SUB;
    root.querySelector('.vl-sms__btn').textContent = BTN;
    root.querySelector('.vl-sms__ctext').textContent = CONSENT;

    var form = root.querySelector('form'), phoneEl = root.querySelector('.vl-sms__phone'),
        okEl = root.querySelector('.vl-sms__ok'), btn = root.querySelector('.vl-sms__btn'),
        msg = root.querySelector('.vl-sms__msg'), hp = root.querySelector('.vl-sms__hp');
    function say(t, cls) { msg.textContent = t; msg.className = 'vl-sms__msg ' + (cls || ''); }
    phoneEl.addEventListener('input', function () { phoneEl.value = fmt(digits(phoneEl.value)); });
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (hp.value) return;
      if (digits(phoneEl.value).length !== 9) { say('Введіть 9 цифр номера після +380.', 'is-err'); phoneEl.focus(); return; }
      if (!okEl.checked) { say('Поставте позначку згоди, щоб ми могли надіслати SMS.', 'is-err'); return; }
      btn.disabled = true; say('Зберігаємо…');
      var body = { phone: '380' + digits(phoneEl.value), consent: true, consent_text: CONSENT, items: [], total: 0,
                   cart_token: '', page: src + ' ' + location.pathname, source: src, hp: '' };
      fetch(EP, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(body) })
        .then(function () {
          try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'vl_sms_lead', vl_sms_source: src });
          form.hidden = true; root.querySelector('.vl-sms__consent').hidden = true;
          say(DONE, 'is-ok');
        })
        .catch(function () { btn.disabled = false; say('Не вдалося зберегти. Спробуйте ще раз.', 'is-err'); });
    });
    return root;
  }

  function ensureCss() {
    if (document.getElementById('vl-sms-css-js')) return;
    var s = document.createElement('style'); s.id = 'vl-sms-css-js'; s.textContent = CSS;
    document.head.appendChild(s);
  }

  function placeAfter(anchor, src) {
    if (!anchor || !anchor.parentNode) return;
    if (document.querySelector('[data-vl-sms-js="' + src + '"]')) return;
    var node = build(src);
    if (!node) return;
    ensureCss();
    anchor.parentNode.insertBefore(node, anchor.nextSibling);
  }

  // Сторінка відписки: /pages/unsubscribe?u=<номер>.<підпис> (посилання з SMS). Відписка йде POST-запитом у веб-застосунок.
  function unsubPage() {
    var path = location.pathname.replace(/\/+$/, '');
    if (path.indexOf('/pages/unsubscribe') !== 0) return;
    var host = document.querySelector('[data-vl-unsub]') || document.querySelector('main');
    if (!host || host.querySelector('.vl-sms')) return;
    var u = new URLSearchParams(location.search).get('u') || '';
    ensureCss();
    var box = document.createElement('div');
    box.className = 'vl-sms';
    box.innerHTML = '<div class="vl-sms__title">Відписка від SMS vlsniy.aroma</div>' +
      '<div class="vl-sms__sub"></div><button type="button" class="vl-sms__btn">Відписатися</button><div class="vl-sms__msg" aria-live="polite"></div>';
    var sub = box.querySelector('.vl-sms__sub'), btn = box.querySelector('.vl-sms__btn'), msg = box.querySelector('.vl-sms__msg');
    if (!/^380\d{9}\.[0-9a-f]{16}$/.test(u)) {
      sub.textContent = 'Посилання недійсне. Напишіть нам, і ми відпишемо вас вручну.';
      btn.hidden = true;
    } else {
      sub.textContent = 'Натисніть кнопку, щоб більше не отримувати від нас SMS.';
      btn.addEventListener('click', function () {
        btn.disabled = true; msg.textContent = 'Зберігаємо…';
        fetch(EP, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify({ type: 'unsub', u: u }) })
          .then(function () { btn.hidden = true; msg.className = 'vl-sms__msg is-ok'; msg.textContent = 'Готово: ви відписалися від SMS vlsniy.aroma.'; })
          .catch(function () { btn.disabled = false; msg.className = 'vl-sms__msg is-err'; msg.textContent = 'Не вдалося зберегти. Спробуйте ще раз.'; });
      });
    }
    host.appendChild(box);
  }

  function run() {
    unsubPage();
    var path = location.pathname.replace(/\/+$/, '') || '/';
    // 1) Головна: під блоком з фільтрами (Бестселери, Акції…)
    if (path === '/' || /^\/(uk|en)$/.test(path)) {
      var chips = document.querySelector('.vlz-chips');
      placeAfter(chips, 'landing');
    }
    // 2) Картка товару: під блоком «Збери свій набір» / кнопками купівлі (поза <form>)
    if (/^\/products\//.test(path)) {
      var pf = document.querySelector('product-form');
      placeAfter(pf, 'product');
    }
    // 3) Будь-яка сторінка: <div data-vl-sms-slot="landing"></div>
    var slots = document.querySelectorAll('[data-vl-sms-slot]');
    for (var i = 0; i < slots.length; i++) {
      var src = slots[i].getAttribute('data-vl-sms-slot') || 'landing';
      if (slots[i].querySelector('.vl-sms')) continue;
      var n = build(src);
      if (n) { ensureCss(); slots[i].appendChild(n); }
    }
  }

  function start() {
    run();
    // секції можуть перемальовуватись (вибір варіанта, застосунки): повертаємо форму, якщо зникла
    var t = null;
    new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; run(); }, 400);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();